import { E_ShareType } from '@eureka/services/src/types/share';

export const cn = {
    shareTools: {
        loggedInShare: '{sharedBy}分享了{shareType}给您，您可以转化为自己的内容，或者提出新问题。',
        loggedOutShare: '{sharedBy}分享了{shareType}给您，登录即可开启探索之旅。',
        [E_ShareType.SEEK_SEARCH]: '技术新发现',
        [E_ShareType.TECH_MIND]: '技术解决方案',
        [E_ShareType.MATERIAL_MIND]: '技术解决方案',
        [E_ShareType.MATERIAL_MIND_V2]: '技术解决方案',
        [E_ShareType.AI_AGENT]: 'AI Agent Flow',
        [E_ShareType.PROJECT]: '项目',
        [E_ShareType.TRIZ_MIND]: 'TRIZ解决方案',
        share: '分享',
        login: '登录',
        loginTip: '<div class="font-semibold text-base mb-1">立即登录</div>收获启发？注册后提出您的问题，获得专属解决方案哦～😊',
        duplicated: '转为我的',
    },
    duplicateDialog: {
        title: '转为我的',
        message: '当前内容处于只读状态',
        duplicateMessage: '当前内容处于只读状态，您需要先将其转换为自己的内容，才能进行保存或编辑哦。',
        confirmButton: '确认',
        cancelButton: '取消',
    },
    duplicatePermissionDialog: {
        title: '抱歉，您当前的权限不支持该功能操作哦',
        desc: '您可以升级套餐，解锁更多使用次数和高级功能哦～',
        upgradeButton: '升级',
    },
    airShareDialog: {
        title: '分享新发现',
        backToShare: '返回分享',
        inviteByAccount: '邮箱分享',
        inviteByLink: '链接分享',
        socialMedia: '或者分享到第三方平台',
        copyLink: '复制链接',
        copyLinkSuccess: '复制链接成功',
        emailPlaceholder: '请输入被分享人的邮箱地址',
        invite: '分享',
        emailInvalid: '请输入正确的邮箱地址',
        emailDuplicate: '邮箱地址重复',
        emailSuccess: '邮箱发送成功',
        removeUserSuccess: '移除用户成功',
        whoHasAccess: '谁可以访问',
        owner: '拥有者',
        remove: '移除',
        sharer: '分享人',
        sharedContent: '内容',
        notJoined: '（已发送邀请）',
        tech_mind_content: '关于"{content}"的解决方案',
        seek_search_content: '关于"{content}"的新发现',
        material_mind_content: '关于"{content}"的解决方案',
        ai_agent_content: '关于"{content}"的解决方案',
        project_content: '关于"{content}"的项目',
        triz_mind_content: '关于"{content}"的TRIZ解决方案',
        accessUsersSummary: '{names}和其他{count}个账户',
        accessUsersOnly: '{names}',
        ira_conversation_content: '{content}',
    },
};

export const en = {
    shareTools: {
        loggedInShare: '{sharedBy} has shared {shareType} with you. Feel free to duplicate it or ask any question.',
        loggedOutShare: '{sharedBy} has shared {shareType} with you, login to explore more.',
        [E_ShareType.SEEK_SEARCH]: 'technical insight',
        [E_ShareType.TECH_MIND]: 'technical solutions',
        [E_ShareType.MATERIAL_MIND]: 'technical solutions',
        [E_ShareType.MATERIAL_MIND_V2]: 'technical solutions',
        [E_ShareType.AI_AGENT]: 'AI Agent Flow',
        [E_ShareType.PROJECT]: 'Project',
        [E_ShareType.TRIZ_MIND]: 'TRIZ Solutions',
        share: 'Share',
        login: 'Login',
        loginTip: '<div class="font-semibold text-base mb-1">Log in now</div>Feeling inspired? Sign up to ask your questions and receive personalized solutions just for you! 😊',
        duplicated: 'Duplicate',
    },
    duplicateDialog: {
        title: 'Duplicate',
        message: 'The current content is read only.',
        duplicateMessage: 'The current content is read only, you will need to convert it to your own before edit it.',
        confirmButton: 'Confirm',
        cancelButton: 'Cancel',
    },
    duplicatePermissionDialog: {
        title: 'Sorry, your current permissions do not support this feature.',
        desc: 'Upgrade your plan to access additional uses and premium features.',
        upgradeButton: 'Upgrade',
    },
    airShareDialog: {
        title: 'Share Project',
        backToShare: 'Back to share',
        inviteByAccount: 'Invite colleague via email',
        inviteByLink: 'Invite colleague via link',
        socialMedia: 'Or you can share with a third-party service',
        copyLink: 'Copy link',
        copyLinkSuccess: 'Copy link success',
        emailPlaceholder: 'Enter the invitee\'s email address',
        invite: 'Invite',
        emailInvalid: 'Please enter a valid email address',
        emailDuplicate: 'Email address duplicate',
        emailSuccess: 'Email sent successfully',
        removeUserSuccess: 'User removed successfully',
        whoHasAccess: 'Who has access',
        owner: 'Owner',
        remove: 'Remove',
        sharer: 'Shared by',
        sharedContent: 'Shared Content',
        notJoined: '(Invite sent)',
        tech_mind_content: 'The technical solutions for "{content}"',
        seek_search_content: 'A new discovery regarding "{content}"',
        material_mind_content: 'The technical solutions for "{content}"',
        ai_agent_content: 'The agent for "{content}"',
        project_content: 'The project for "{content}"',
        triz_mind_content: 'The TRIZ solutions for "{content}"',
        accessUsersSummary: '{names} and {count} other participants',
        accessUsersOnly: '{names}',
        ira_conversation_content: '{content}',
    },

};

export const jp = {
    shareTools: {
        loggedInShare: '{sharedBy}があなたに{shareType}を共有しました。ログインして探索の旅を始めましょう。',
        loggedOutShare: '{sharedBy}があなたに{shareType}を共有しました。ログインして探索の旅を始めましょう',
        [E_ShareType.SEEK_SEARCH]: '技術的新発見',
        [E_ShareType.TECH_MIND]: '技術的な解決策',
        [E_ShareType.MATERIAL_MIND]: '技術的な解決策',
        [E_ShareType.MATERIAL_MIND_V2]: '技術的な解決策',
        [E_ShareType.AI_AGENT]: 'AI Agent Flow',
        [E_ShareType.PROJECT]: 'プロジェクト',
        [E_ShareType.TRIZ_MIND]: 'TRIZ解決策',
        share: '共有',
        login: 'ログイン',
        loginTip: '<div class="font-semibold text-base mb-1">今すぐログイン</div>ひらめきを感じましたか？登録するとご質問を投稿でき、あなた専用の解決策をご案内しますよ〜😊',
        duplicated: 'コピー',
    },
    duplicateDialog: {
        title: 'コピー',
        message: '現在のコンテンツは読み取り専用です。',
        duplicateMessage: '現在のコンテンツは読み取り専用です。保存または編集するには、まず自分のコンテンツに変換する必要があります。',
        confirmButton: 'コピー',
        cancelButton: 'キャンセル',
    },
    duplicatePermissionDialog: {
        title: '申し訳ありませんが、現在の権限ではこの機能を使用できません',
        desc: 'プランをアップグレードして、より多くの使用回数と高度な機能をアンロックできますよ～',
        upgradeButton: 'アップグレード',
    },
    airShareDialog: {
        title: 'プロジェクトを共有',
        backToShare: '共有に戻る',
        inviteByAccount: 'アカウントで招待',
        inviteByLink: 'リンクで招待',
        socialMedia: 'またはサードパーティプラットフォームに共有する',
        copyLink: 'リンクをコピー',
        copyLinkSuccess: 'リンクをコピーしました',
        emailPlaceholder: '招待する相手のメールアドレスを入力',
        invite: '招待',
        emailInvalid: '有効なメールアドレスを入力してください',
        emailDuplicate: 'メールアドレスが重複しています',
        emailSuccess: 'メールが送信されました',
        removeUserSuccess: 'ユーザーが削除されました',
        whoHasAccess: 'アクセス権限を持つユーザー',
        owner: 'オーナー',
        remove: '削除',
        sharer: '共有者',
        sharedContent: '内容',
        notJoined: '（招待が送信されました）',
        tech_mind_content: '"{content}"に関する解決策',
        seek_search_content: '"{content}"に関する新しい発見',
        material_mind_content: '"{content}"に関する解決策',
        ai_agent_content: '"{content}"に関するエージェント',
        project_content: '"{content}"に関するプロジェクト',
        triz_mind_content: '"{content}"に関するTRIZ解決策',
        accessUsersSummary: '{names}と他の{count}アカウント',
        accessUsersOnly: '{names}',
        ira_conversation_content: '{content}',
    },
};

export const tw = {
    shareTools: {
        loggedInShare: '{sharedBy}分享了{shareType}給您，您可以轉換為自己的內容，或者提出新問題。',
        loggedOutShare: '{sharedBy}分享了{shareType}給您，登錄即可開啓探索之旅。',
        [E_ShareType.SEEK_SEARCH]: '技術解決方案',
        [E_ShareType.TECH_MIND]: '技術解決方案',
        [E_ShareType.MATERIAL_MIND]: '技術解決方案',
        [E_ShareType.MATERIAL_MIND_V2]: '技術解決方案',
        [E_ShareType.AI_AGENT]: 'AI Agent Flow',
        [E_ShareType.PROJECT]: '项目',
        [E_ShareType.TRIZ_MIND]: 'TRIZ解決方案',
        share: '分享',
        login: '登入',
        loginTip: '<div class="font-semibold text-base mb-1">立即登入</div>註冊後即可提出您的問題，獲得專屬解決方案喔～😊',
        duplicated: '轉為我的',
    },
    duplicatePermissionDialog: {
        title: '抱歉，您目前的權限無法使用此功能',
        desc: '您可以升級套餐，解鎖更多使用次數和高級功能哦～',
        upgradeButton: '升級',
    },
    duplicateDialog: {
        title: '轉為我的',
        message: '當前內容處于只讀狀態。',
        duplicateMessage: '當前內容處于只讀狀態，您需要先將其轉換為自己的內容，才能進行保存或編輯哦。',
        confirmButton: '確認',
        cancelButton: '取消',
    },
    airShareDialog: {
        title: '分享新發現',
        backToShare: '返回分享',
        inviteByAccount: '郵箱分享',
        inviteByLink: '鏈接分享',
        socialMedia: '或者分享到第三方平臺',
        copyLink: '複制鏈接',
        copyLinkSuccess: '複製鏈接成功',
        emailPlaceholder: '請輸入被分享人的郵箱地址',
        invite: '分享',
        emailInvalid: '請輸入正確的郵箱地址',
        emailDuplicate: '郵箱地址重複',
        emailSuccess: '郵箱發送成功',
        removeUserSuccess: '移除用戶成功',
        whoHasAccess: '誰可以訪問',
        owner: '擁有者',
        remove: '移除',
        sharer: '分享人',
        sharedContent: '内容',
        notJoined: '（邀請已發送）',
        tech_mind_content: '關于"{content}"的解決方案',
        seek_search_content: '關于"{content}"的新發現',
        material_mind_content: '關于"{content}"的解決方案',
        ai_agent_content: '關于"{content}"的解決方案',
        project_content: '關于"{content}"的項目',
        triz_mind_content: '關于"{content}"的TRIZ解決方案',
        accessUsersSummary: '{names}和其他{count}個賬戶',
        accessUsersOnly: '{names}',
        ira_conversation_content: '{content}',
    },
};
